import * as React from 'react'

function LeftLongArrow(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={17.994} height={9.002} viewBox="0 0 17.994 9.002" {...props}>
      <g data-name="Group 52081">
        <path
          data-name="Union 29"
          d="M4.686 9.3L.1 4.8 4.686.3v2.193L3.132 4.019h14.96v1.565H3.133l1.553 1.524V9.3z"
          transform="translate(.886 .682) translate(-.985 -.982)"
          fill="CurrentColor"
        />
      </g>
    </svg>
  )
}

export default LeftLongArrow
